import { Search, SlidersHorizontal } from "lucide-react";
import { useMemo, useState } from "react";
import { CATEGORIES } from "@/data/products";
import ProductCard from "@/components/ProductCard";

export default function ArmoryCatalog({ products, onAdd, onInspect }) {
  const [category, setCategory] = useState("ALL GEAR");
  const [query, setQuery] = useState("");
  const visibleProducts = useMemo(() => products.filter((product) => {
    const matchesCategory = category === "ALL GEAR" || product.category === category;
    const search = query.trim().toLowerCase();
    return matchesCategory && (!search || `${product.name} ${product.category}`.toLowerCase().includes(search));
  }), [category, products, query]);
  return (
    <section className="armory-section section-shell" id="armory" data-testid="armory-catalog">
      <div className="section-lead"><p className="eyebrow">02 / THE ARMORY</p><h2>Pick the signal.<br /><em>Keep the edge.</em></h2><p>Affordable field essentials to mission-critical hardware. Every unit arrives with its source, spec, and support contribution visible.</p></div>
      <div className="catalog-tools">
        <div className="filter-label"><SlidersHorizontal size={15} /> FILTER BY CLASS</div>
        <div className="filter-row">{CATEGORIES.map((item) => <button className={category === item ? "filter-button active" : "filter-button"} key={item} onClick={() => setCategory(item)} data-testid={`filter-${item.toLowerCase().replaceAll(" ", "-")}-btn`}>{item}</button>)}</div>
        <label className="search-box"><Search size={16} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="SEARCH THE ARMORY" data-testid="catalog-search-input" /></label>
      </div>
      <div className="catalog-readout"><span>{String(visibleProducts.length).padStart(2, "0")} UNITS READIED</span><span>ENTRY $24 / SPECOPS $899</span></div>
      <div className="product-grid">{visibleProducts.map((product) => <ProductCard key={product.id} product={product} onAdd={onAdd} onInspect={onInspect} />)}</div>
      {!visibleProducts.length && <div className="empty-search" data-testid="catalog-empty-state">NO UNITS MATCH THAT SIGNAL. CLEAR SEARCH TO REOPEN THE ARMORY.</div>}
    </section>
  );
}
